'use strict';

module.exports = '2.26.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 361
// module chunks = 168707334958949